import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgPlus = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", { d: "M12.8906 4C12.8906 3.44772 12.4429 3 11.8906 3C11.3383 3 10.8906 3.44772 10.8906 4V11L3.89062 11C3.33834 11 2.89062 11.4477 2.89062 12C2.89062 12.5523 3.33834 13 3.89062 13H10.8906V20C10.8906 20.5523 11.3383 21 11.8906 21C12.4429 21 12.8906 20.5523 12.8906 20V13H19.8906C20.4429 13 20.8906 12.5523 20.8906 12C20.8906 11.4477 20.4429 11 19.8906 11L12.8906 11V4Z" })]
});
const ForwardRef = forwardRef(SvgPlus);
export { ForwardRef as ReactComponent };
